import { JSX } from 'react';
import { mappedTeacherSchedule } from 'entities/types';
import { mappedGroupSchedule } from 'entities/types';

import { ColumnSchedule } from '../../columnSchedule';

export const makeColumns = (
  data: mappedGroupSchedule | mappedTeacherSchedule,
) => {
  const res: JSX.Element[] = [];
  data.forEach((item, index) => {
    res.push(
      <ColumnSchedule data={item} key={item[0] ? item[0].key : index} />,
    );
  });
  return res;
};
